import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerBody,
  Box,
  DrawerHeader,
  Text,
  Button,
  Spinner,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
} from "@chakra-ui/react";
import { useContext, useEffect, useState } from "react";
import AddDocumentModal from "./AddDocumentModal";
import { appRequest } from "routes";
import { AppContext } from "AppProvider/AppContext";
import FileViewer from "../FileViewerModal/FileViewer";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  selectedRows?: any;
  handleGet?: any;
};

export default function AddtionalDocumentModal({
  isOpen,
  onClose,
  selectedRows,
  handleGet,
}: ModalProps): JSX.Element {
  const { toastNotify, accountDetails, workFlowData } = useContext(AppContext);
  const [selectedFile, setSelectedFile] = useState<any>(null);
  const [showFileViewer, setFileViewer] = useState(false);
  const [fetchFileLoader, setFetchFileLoader] = useState(false);
  const [addDocument, setAddDocument] = useState<any>({
    open: false,
    documents: [],
  });
  const [sample, setSample] = useState({
    url: "",
    file: null,
    type: null,
    buffer: null,
  });
  const width = "40vw"; // Adjust width as needed

  useEffect(() => {
    if (selectedFile) {
      getFile();
    }
  }, [selectedFile]);

  const getFile = async () => {
    try {
      if (selectedFile) {
        setFetchFileLoader(true);
        const response: any = await appRequest("filesystem", "get", {
          id: selectedFile._id,
        });
        if (response) {
          if (!response.error) {
            let buffer =
              typeof response === "string" ? JSON.parse(response) : response;
            buffer = new Uint8Array(buffer);

            const fileURL = URL.createObjectURL(
              new Blob([buffer], {
                type: selectedFile?.metadata?.contentType,
              }),
            );

            setSample({
              url: fileURL,
              file: selectedFile,
              type: selectedFile?.metadata?.contentType,
              buffer: buffer,
            });
          }
        }
      }
    } catch (error: any) {
      toastNotify({
        title: "Error",
        message: error.message,
        type: "error",
      });
    } finally {
      setFetchFileLoader(false);
    }
  };

  return (
    <>
      <Drawer
        isOpen={showFileViewer}
        placement="right"
        onClose={() => setFileViewer(false)}
        size="xl"
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>File Viewer</DrawerHeader>
          <DrawerBody
            px={{ base: ".5rem", lg: "1.5rem" }}
            py=".2rem"
            overflowY="auto"
            className="customScrollBar"
          >
            {fetchFileLoader ? (
              <Box
                h={{ base: "30vh", md: "40vh", lg: "80vh" }}
                mb="1rem"
                w="100%"
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
              >
                <Spinner
                  size="xl"
                  thickness="4px"
                  speed="0.65s"
                  color="teal.400"
                />
              </Box>
            ) : (
              <Box
                h={{ base: "30vh", md: "40vh", lg: "85vh" }}
                // w={{ lg: "40vw" }}
              >
                <FileViewer sample={sample} />
              </Box>
            )}
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size={{ base: "full", lg: "2xl" }}
        isCentered
      >
        <ModalOverlay bg="rgba(0, 0, 0, 0.2)" />
        <ModalContent
          position="fixed"
          right={isOpen ? "0" : `-${width}`}
          top="0"
          height="100vh"
          width={{ base: "100%", lg: width }}
          animation={`${
            isOpen ? "slideIn" : "slideOut"
          } 0.8s ease-in-out forwards`}
        >
          <ModalHeader
            fontSize={{ base: "md", lg: "xl" }}
            color="teal.300"
            fontWeight="700"
            p=".6rem .6rem"
            ml="1rem"
          >
            Documents
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody
            px={{ base: ".5rem", lg: "1.5rem" }}
            py=".2rem"
            overflowY="auto"
            className="customScrollBar"
            mb={{ base: "1rem", lg: "unset" }}
          >
            <Box h="100%">
              <Button
                mb={5}
                w="full"
                colorScheme="teal"
                size="md"
                boxShadow="md"
                _hover={{ bg: "teal.600", boxShadow: "lg" }}
                onClick={() => setAddDocument({ open: true })}
              >
                Add Documents
              </Button>
              {selectedRows[0]?.additionalFilesDetails?.filter(
                (item: any) => item && Object.keys(item).length > 0,
              )?.length ? (
                selectedRows[0]?.additionalFilesDetails
                  ?.filter((item: any) => item && Object.keys(item).length > 0)
                  ?.map((item: any, index: number) => (
                    <Box
                      key={index}
                      mb={4}
                      p={2}
                      bg="gray.50"
                      borderRadius="md"
                      _hover={{ bg: "gray.100", cursor: "pointer" }}
                      onClick={() => {
                        setFileViewer(true);
                        setSelectedFile(item);
                      }}
                    >
                      <Text fontSize="md" fontWeight="500" color="teal.600">
                        {item?.filename}
                      </Text>
                    </Box>
                  ))
              ) : (
                <Text
                  textAlign="center"
                  fontWeight="bold"
                  mt={"35vh"}
                  cursor="pointer"
                >
                  No Documents are Found
                </Text>
              )}
              <AddDocumentModal
                selectedRows={selectedRows}
                isOpen={addDocument.open}
                onClose={() => {
                  onClose();
                  setAddDocument({ open: false });
                }}
                handleGet={handleGet}
              />
            </Box>
          </ModalBody>
        </ModalContent>
        <style>
          {`
              @keyframes slideIn {
                from {
                  right: -${width};
                }
                to {
                  right: 0;
                }
              }
              @keyframes slideOut {
                from {
                  right: 0;
                }
                to {
                  right: -${width};
                }
              }
            `}
        </style>
      </Modal>
    </>
  );
}